import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';

export class AemPropertyAccessor {
  private static getValue(aem: HeaderFooterMachCore, path: string): unknown {
    return path
      .split('.')
      .reduce(
        (obj: unknown, key) => (obj as Record<string, unknown>)?.[key],
        aem?.header?.book?.stays
      );
  }

  static getString(aem: HeaderFooterMachCore, path: string): string {
    return (this.getValue(aem, path) as string) ?? '';
  }

  static getBoolean(aem: HeaderFooterMachCore, path: string): boolean {
    return (this.getValue(aem, path) as boolean) ?? false;
  }

  static getArray<T>(aem: HeaderFooterMachCore, path: string): T[] {
    return (this.getValue(aem, path) as T[]) ?? [];
  }
}
